export default "__VITE_ASSET__DQ53ptfC__"